module.exports = __webpack_public_path__ + "static/media/features-shiftManagement.5ba8ef89.png";